import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { Actions as ACTIONS } from '../../store/actions/payrollActions';
import ReactDOM from "react-dom";
import _ from 'lodash';
import "react-datepicker/dist/react-datepicker.css";
import 'react-notifications/lib/notifications.css';
import { format, setHours, setMinutes, setSeconds } from 'date-fns'
import { XMarkIcon } from '@heroicons/react/20/solid'
import Spinner from "../common/Spinner";


const timeToHours = time => {

  const parts = time.split(':');

  const hours = parseInt(parts[0]) + (parseInt(parts[1]) / 60);

  return hours;
}

const UnprocessTimesheetModal = ({
  employee,
  agreementID,
  closeModal,
  unprocessTimesheets,
  processing

}) => {


  if (!employee) {
    return (<div></div>)
  }

  return (
    <div className="modal" tabindex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="block block-themed block-transparent remove-margin-b" style={{ padding: 0 }}>
            <div className="block-header bg-primary-dark" style={{ padding: "15px 20px" }}>
              <ul className="block-options">
                <li>
                  <button type="button" onClick={() => { closeModal() }}>
                    <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                  </button>
                </li>
              </ul>
              <h3 className="block-title">Unprocess Timesheet</h3>
            </div>
            <div className="block-content" style={{ padding: "20px 20px 1px" }}>

              <p>Would you like to unprocess the timesheets for {employee.employeeName} {employee.employeeSurname}?</p>

              <p>Any allowances related to timesheets will be removed, and any auto-paid leave will also be removed.</p>

              <div className="clearfix"></div>
              <div className="block buttons">

                {processing ?
                  <button
                    className="btn btn-danger pull-right"
                    style={{ marginRight: 0, pointerEvents: "none" }}
                  >
                    <Spinner
                      style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
                      className="animate-spin -ml-1 mr-3 h-5 w-5 "
                    />
                  </button>
                  : <button
                    className="btn btn-danger pull-right"
                    onClick={() => unprocessTimesheets()}
                    style={{ marginRight: 0 }}
                  >Unprocess Timesheets for {employee.employeeName} {employee.employeeSurname}</button>
                }


                <div className="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {

  const agreementID = state.payroll.unprocessPayslipModal;
  const employee = agreementID && _.find(state.payroll.employees, { id: agreementID })
  const processing = state.payroll.unprocessTimesheetLoading;

  return {
    agreementID,
    employee,
    processing
  }
}

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(ACTIONS.unprocessTimesheetsModal(false)),
  unprocessTimesheets: () => dispatch(ACTIONS.unprocessTimesheets()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UnprocessTimesheetModal) 
